// ExchangeStageDone.jsx
import React, { useMemo } from "react";
import { Alert, Button, Descriptions, Tag, Typography } from "antd";
import Shell from "./ui/Shell";
import { formatUtc } from "./utils/time";

const { Text } = Typography;

function normalizeStatus(s) {
  return String(s || "").toUpperCase();
}

function statusTag(status) {
  const s = normalizeStatus(status);
  if (s === "DISPUTE") return <Tag color="red">СПОР</Tag>;
  if (s === "CANCELLED" || s === "CANCELED") return <Tag>ОТМЕНЕНА</Tag>;
  if (s === "COMPLETED" || s === "DONE") return <Tag color="green">ЗАВЕРШЕНА</Tag>;
  if (s === "IN_PROGRESS" || s === "IN_PROCESS") return <Tag color="gold">В ПРОЦЕССЕ</Tag>;
  if (s === "CREATED") return <Tag color="blue">СОЗДАНА</Tag>;
  return <Tag>{s || "—"}</Tag>;
}

export default function ExchangeStageDone({ stage, onRestart, tx }) {
  const rateValue = useMemo(() => {
    const num = (v) => {
      const n = typeof v === "number" ? v : Number(String(v ?? "").replace(",", "."));
      return Number.isFinite(n) ? n : NaN;
    };

    const direct = num(tx?.rate ?? tx?.exchange_rate ?? null);
    if (Number.isFinite(direct) && direct > 0) return direct;

    const buy = num(tx?.pair?.buy_rate ?? null);
    const ratio = num(tx?.pair?.ratio_rate ?? 1);
    if (Number.isFinite(buy) && buy > 0 && Number.isFinite(ratio) && ratio > 0) return buy * ratio;

    const af = num(tx?.amount_from ?? null);
    const at = num(tx?.amount_to ?? null);
    if (Number.isFinite(af) && af > 0 && Number.isFinite(at) && at > 0) return at / af;

    return null;
  }, [tx]);

  const rateText = rateValue
    ? `1 ${tx?.currency_from ?? tx?.pair?.currency_from ?? "—"} = ${rateValue.toFixed(6)} ${
        tx?.currency_to ?? tx?.pair?.currency_to ?? "—"
      }`
    : "—";

  return (
    <Shell
      stage={stage}
      title="Завершение"
      subtitle="Этап 4. Заявка завершена."
      minBodyHeight={480}
    >
      <Alert type="success" showIcon message="Готово" description="Операция завершена. Спасибо." />

      {/* ДОБАВЛЕНО: блок с данными сделки */}
      <div className="mt-6">
        <Descriptions size="small" bordered column={1} labelStyle={{ width: 220 }}>
          <Descriptions.Item label="ID заявки">{tx?.id || "—"}</Descriptions.Item>

          <Descriptions.Item label="Статус">
            <div className="flex items-center gap-2">
              {statusTag(tx?.status)}
              <Text type="secondary">{normalizeStatus(tx?.status)}</Text>
            </div>
          </Descriptions.Item>

          <Descriptions.Item label="Отдаёте">
            {tx?.amount_from ?? "—"} {tx?.currency_from ?? tx?.pair?.currency_from ?? "—"}
          </Descriptions.Item>

          <Descriptions.Item label="Получаете">
            {tx?.amount_to ?? "—"} {tx?.currency_to ?? tx?.pair?.currency_to ?? "—"}
          </Descriptions.Item>

          <Descriptions.Item label="Валютная пара">
            {tx?.pair?.currency_from || "—"} → {tx?.pair?.currency_to || "—"}
          </Descriptions.Item>

          <Descriptions.Item label="Курс">{rateText}</Descriptions.Item>

          <Descriptions.Item label="Реквизиты">
            {tx?.payout?.detail || "—"} ({tx?.pair?.method_to?.title || "—"})
          </Descriptions.Item>

          <Descriptions.Item label="Создана">
            {tx?.created_at ? formatUtc(tx.created_at) : "—"}
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className="mt-6 flex justify-center">
        <Button onClick={onRestart}>Создать новую заявку</Button>
      </div>
    </Shell>
  );
}